export const Intersection_observer = (handleIntersect, element, threshold = 0.2) => {
    let options = {
        root: null,
        threshold
    }

    let observer = new IntersectionObserver(handleIntersect, options)
    observer.observe(element)
}
